<template>
  <div class="flex w-full justify-between">
    <div>{{ params.displayName }}</div>
    <IconPlus
      v-if="hide"
      class="h-3 w-3 cursor-pointer object-contain text-white"
      @click="onHide"
    />
    <IconMinus
      v-else
      class="h-3 w-3 cursor-pointer object-contain text-white"
      @click="onHide"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import IconPlus from '~/assets/icons/plus.svg'
import IconMinus from '~/assets/icons/minus.svg'
import type { IHeaderParams } from 'ag-grid-community'

type CustomHeaderParams = IHeaderParams & {
  childrenColumns: string[]
}

const props = defineProps<{
  params: CustomHeaderParams
}>()

const hide = ref(false)

onMounted(() => {
  hide.value = !props.params.api
    .getColumn(props.params.childrenColumns[0])
    .isVisible()
})

const onHide = () => {
  hide.value = !hide.value
  props.params.api.setColumnsVisible(props.params.childrenColumns, !hide.value)
}
</script>
